import { KYMW1404Model } from '../kymw1404.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { NominationGoodsSearchConditionModel } from '../vo/nomination-goods-search-condition.model';

/**
 * 掲載候補商品リスト情報を取得する。
 *
 * @export
 * @class GetNominationGoodsDataService
 * @extends {PlessResponderSub}
 */
@Injectable()
export class GetNominationGoodsDataService extends PlessJsonResponderSub<any> {

  private vo: NominationGoodsSearchConditionModel = null;
  private model: KYMW1404Model = null;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetNominationGoodsDataService
   */
  private getBody(): PlessRequest {
    const combinations = this.vo.classCodeArray.map(classCode => ({
      parameter: {
        ClassCodeArray: classCode
      }
    }));

    const dutiesFormDailies = this.vo.dutiesFormDailyList?.map(dfd => ({
      parameter: {
        DutiesFormDailyDiv: dfd
      }
    }));

    const pCodeList = this.vo.pcodeList.length === 0
      ? [{
        parameter: {
          PCode: ''
        }
      }]
      : this.vo.pcodeList.map(pcode => ({
        parameter: {
          PCode: pcode
        }
      }));

    return new PlessRequest({
      search: {
        Rec: {
          parameter: {
            FormID: this.vo.formID,
            OrderCode: this.vo.orderCode,
            MediumType: this.vo.mediumType,
            CoopCode: this.vo.coopCode,
            PageNum: this.vo.pageNum,
            SellAreaCode: this.vo.sellAreaCode,
            ClassCode: this.vo.classCode,
            OrderNumQuota: this.vo.orderNumQuota,
            WPublishFlg: this.vo.wPubilshFlg,
            NotPublishFlg: this.vo.notPublishFlg,
            GuideGoodsName: this.vo.guideGoodsName,
            OtherMediumTypeFlg: this.vo.otherMediumTypeFlg,
            SortItem: this.vo.sortItem,
            SortOrder: this.vo.sortOrder,
            Page: this.vo.page,
            OrderGoodsFlg: this.vo.orderGoodsFlg,
          },
          combination: combinations
        },
        DutiesFormDailyDivList: {
          combination: dutiesFormDailies
        },
        PCodeList: {
          combination: pCodeList
        },
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param {KYMW1404Model} model
   * @param {NominationGoodsSearchConditionModel} vo
   * @memberof GetNominationGoodsDataService
   */
  execute(model: KYMW1404Model, vo: NominationGoodsSearchConditionModel) {
    this.model = model;
    this.vo = vo;
    this.send('getNominationGoodsData', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetNominationGoodsDataService
   */
  success(data: any) {
    // 結果データの編集
    this.model.updateServerResponse(data);

    if (this.model.searchValueChangeFlag === false) {
      this.model.kymw1404Component.reDraw();
    }

    // 一覧の背景色を設定
    this.model.kymw1404Component.setColorPattern();

    this.model.kymw1404Component.cmb_SellAreaName.nativeElement.focus();
  }

  /**
   * API通信失敗時処理
   *
   * @param {*} _
   * @memberof GetNominationGoodsDataService
   */
  plessErrorHandler(_: any): void {
    if (this.model.searchValueChangeFlag === false) {
      this.model.kymw1404Component.reDraw();
    }
  }
}
